import { AnyAction } from 'redux'
import { getSupplierId, myLaunchStateType, resetObj } from '../../../tools/util'
import { useEffect } from 'react'
import { history, useTypedSelector } from '../../../redux/store'
import { useDispatch } from 'react-redux'
import { userRouter } from '../../../route'
import { message } from 'antd'
import { GET_AUDITLIST, POST_RECALL_API } from '../../../api/MaterialApi'
import { CustomerConfirm } from '../../../components/ModalUser'
import { POST_GIVEUP_API } from '../../../api/BrandApi'
import { productStatusEnum } from '@/global/enum/product'
import { useQuery } from '../../../tools/utilHooks'

// action 类型定义
const LAUNCHGOODS_ACTION_TYPE = {
  GET_DATA: 'LAUNCHGOODS/GET_Data', // 获取数据
  SET_DATA: 'LAUNCHGOODS/SET_Data', // 设置数据
  SEARCH_DATA: 'LAUNCHGOODS/Search_Data', // 搜索数据
  CHANGE_PAGES: 'LAUNCHGOODS/Change_Pages', // 分页
  SET_LOADING: 'LAUNCHGOODS/Loading', // 加载中。。。
  CHANGE_DATA: 'LAUNCHGOODS/CHANGE_DATA', // 替换所有状态
}
const {
  GET_DATA,
  SET_DATA,
  SEARCH_DATA,
  CHANGE_PAGES,
  SET_LOADING,
  CHANGE_DATA,
} = LAUNCHGOODS_ACTION_TYPE
// 当前状态接口
interface SearchItem {
  brand: string
  checkMan: string
  checkState: string
  name: string
}
interface LaunchgoodsState {
  dataSource: { data: any[]; total: number; loading: boolean }
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
}
// 默认数据
const defaultState: LaunchgoodsState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100, loading: true },
  // 初始化搜索条件
  searchdata: {},
  // 初始化分页
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
}
// 默认 Reducer
export const reducer = (state = defaultState, action: AnyAction) => {
  let arr = { ...state }
  switch (action.type) {
    // 初始化数据
    case GET_DATA:
      arr.pages.pageNo = 1
      arr.pages.pageSize = 25
      arr.searchdata = resetObj(arr.searchdata)
      return arr
    case SET_DATA:
      arr.dataSource = action.value.dataSource
      arr.pages.pageNo = action.value.pageNo
      return arr
    case SEARCH_DATA:
      // 搜索 重置 分页
      arr.searchdata = action.value
      arr.pages.pageNo = 1
      return arr
    case CHANGE_PAGES:
      arr.pages = action.value
      return arr
    case SET_LOADING:
      arr.dataSource.loading = action.value
      return arr
    case CHANGE_DATA:
      arr = action.value
      return arr
    default:
      return state
  }
}

// 设置数据
const setdataAction = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}) => ({
  type: SET_DATA,
  value: param,
})
// 切换分页
const changepageAction = (param: { pageNo: number; pageSize?: number }) => ({
  type: CHANGE_PAGES,
  value: param,
})
// 搜索
const changesearchdataAction = (param: SearchItem) => ({
  type: SEARCH_DATA,
  value: param,
})
// loading
const changeloadingAction = (param: boolean) => ({
  type: SET_LOADING,
  value: param,
})

const useLaunchgoodsHook = () => {
  const state = useTypedSelector((state) => state.myReuestReducer)
  const dispatch = useDispatch()
  const { dataSource, pages } = state

  const supRoute = userRouter[1].url
  const query = useQuery()
  const status = query.get('status') || ''

  useEffect(() => {
    if (status === 'reject') {
      getdata({ ...state, ...{ searchdata: { checkState: '22' } } })
    } else {
      getdata(state)
    }

    // eslint-disable-next-line
  }, [status])

  // 获取列表数据
  const getdata = async (launchgoodsState: LaunchgoodsState) => {
    dispatch(changeloadingAction(true))
    // 在saga处理中 获取state
    const params = { ...launchgoodsState.pages, ...launchgoodsState.searchdata }
    const data = await GET_AUDITLIST({
      pageNo: params.pageNo, // 页码
      pageSize: params.pageSize, // 分页尺寸
      brand: params.brand,
      checkMan: params.checkMan,
      checkState: params.checkState,
      auditStartDate: params.auditStartDate,
      auditEndDate: params.auditEndDate,
      name: params.name,
      supplierId: getSupplierId(),
      schemeId: params.schemeId,
      tempCode: params.tempCode,
      model: params.model,
      unitCode: params.unitCode,
    })
    if (data.code === 0) {
      const resdata = data.data.content
      const count = data.data.totalCount
      const action = setdataAction({
        dataSource: { data: resdata, total: count, loading: false },
        pageNo: data.data.pageNo,
      })
      dispatch(action)
    } else {
      message.warning(data.msg)
      dispatch(changeloadingAction(false))
    }
  }

  // 搜索
  const onSearch = (params: any) => {
    // SearchItem
    const action = changesearchdataAction(params)
    dispatch(action)
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 分页
  const onChange = (pageNo: number, pageSize?: number) => {
    const action = changepageAction({
      pageNo: pageNo,
      pageSize: pageSize,
    })
    dispatch(action)
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    getdata(state)
  }

  // // 再次提交
  // const passSwitch = () => {
  //   const canReSubmit = checkData.every((item) => item.canReSubmit)
  //   if (checkData.length && canReSubmit) {
  //     const idArr = checkData.map((item) => item.id)
  //     CustomerConfirm({
  //       title: '提示',
  //       content: '确认再次提交？',
  //       onOk: () => {
  //         submitdata(String(idArr))
  //       },
  //     })
  //   } else if (!canReSubmit) {
  //     message.warn('含有不可通过项')
  //   } else {
  //     message.warn('请先勾选数据，再提交')
  //   }
  // }

  // // 批量 再次提交
  // const submitdata = async (assessId: string) => {
  //   message.loading('提交中', 0)
  //   const resData = await POST_RESUNBNIT_API({ assessIds: assessId })
  //   if (resData.code === 0) {
  //     message.success('已提交')
  //     getdata(state)
  //   }
  // }

  // 放弃
  const nopassSwitch = (id: string) => {
    const idArr = id
    CustomerConfirm({
      title: '提示',
      content: '确认放弃申请？',
      onOk: () => {
        givedata(String(idArr))
      },
    })
  }

  // 批量 放弃申请
  const givedata = async (assessId: string) => {
    message.loading('放弃中', 0)
    const resData = await POST_GIVEUP_API({ productIds: assessId })
    if (resData.code === 0) {
      message.success('已放弃')
      getdata(state)
    } else {
      message.destroy()
    }
  }

  // 撤回
  const onRecall = (info: any) => {
    CustomerConfirm({
      title: '提示',
      content: '确定撤回?',
      onOk() {
        recallApi(info)
      },
    })
  }

  // 撤回 recallApi
  const recallApi = async (assessId: string) => {
    message.loading('撤回中', 0)
    const resData = await POST_RECALL_API({ productId: assessId })
    if (resData.code === 0) {
      message.success('已撤回')
      getdata(state)
    }
  }

  // 物料编码跳转
  const onJump = (info: any) => {
    const assessState: myLaunchStateType = info.state
    const productMdmId = info.productMdmId
    // 审核来源：修改审核中→修改；其余（新增审核中/暂存/驳回/撤回）按新增兜底。
    // 实际资质场景以详情返参 auditType 为准（详情页 setDetailAuditType 推算）。
    let auditSource = 'SRM_SECOND_ADD'
    if (productStatusEnum.isLabelsMatchValue(['修改审核中'], assessState)) {
      auditSource = 'SRM_UPDATE'
    }
    if (
      productStatusEnum.isLabelsMatchValue(
        ['驳回', '撤回', '暂存'],
        assessState,
      )
    ) {
      // 编辑
      history.replace({
        pathname: `${supRoute}/launchgoodsInfo`,
        state: {
          productId: info.id,
          productMdmId: productMdmId,
          BtnState: [
            'Edit',
            productStatusEnum.isLabelsMatchValue(['驳回', '撤回'], assessState)
              ? 'AssessReject'
              : undefined,
          ],
          auditSource,
        },
      })
    } else {
      // 详情
      history.replace({
        pathname: `${supRoute}/goodsdetail`,
        state: {
          tempId: info.tempId,
          tempCode: info.tempCode,
          productId: info.id,
          BtnState: ['Detail'],
          auditSource,
        },
      })
    }
  }
  return {
    dataSource,
    pages,
    onSearch,
    onChange,
    onJump,
    onRecall,
    onRefresh,
    nopassSwitch,
    recallApi,
  }
}
export default useLaunchgoodsHook
import { AnyAction } from 'redux'
import { getSupplierId, myLaunchStateType, resetObj } from '../../../tools/util'
import { useEffect } from 'react'
import { history, useTypedSelector } from '../../../redux/store'
import { useDispatch } from 'react-redux'
import { userRouter } from '../../../route'
import { message } from 'antd'
import { GET_AUDITLIST, POST_RECALL_API } from '../../../api/MaterialApi'
import { CustomerConfirm } from '../../../components/ModalUser'
import { POST_GIVEUP_API } from '../../../api/BrandApi'
import { productStatusEnum } from '@/global/enum/product'
import { useQuery } from '../../../tools/utilHooks'

// action 类型定义
const LAUNCHGOODS_ACTION_TYPE = {
  GET_DATA: 'LAUNCHGOODS/GET_Data', // 获取数据
  SET_DATA: 'LAUNCHGOODS/SET_Data', // 设置数据
  SEARCH_DATA: 'LAUNCHGOODS/Search_Data', // 搜索数据
  CHANGE_PAGES: 'LAUNCHGOODS/Change_Pages', // 分页
  SET_LOADING: 'LAUNCHGOODS/Loading', // 加载中。。。
  CHANGE_DATA: 'LAUNCHGOODS/CHANGE_DATA', // 替换所有状态
}
const {
  GET_DATA,
  SET_DATA,
  SEARCH_DATA,
  CHANGE_PAGES,
  SET_LOADING,
  CHANGE_DATA,
} = LAUNCHGOODS_ACTION_TYPE
// 当前状态接口
interface SearchItem {
  brand: string
  checkMan: string
  checkState: string
  name: string
}
interface LaunchgoodsState {
  dataSource: { data: any[]; total: number; loading: boolean }
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
}
// 默认数据
const defaultState: LaunchgoodsState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100, loading: true },
  // 初始化搜索条件
  searchdata: {},
  // 初始化分页
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
}
// 默认 Reducer
export const reducer = (state = defaultState, action: AnyAction) => {
  let arr = { ...state }
  switch (action.type) {
    // 初始化数据
    case GET_DATA:
      arr.pages.pageNo = 1
      arr.pages.pageSize = 25
      arr.searchdata = resetObj(arr.searchdata)
      return arr
    case SET_DATA:
      arr.dataSource = action.value.dataSource
      arr.pages.pageNo = action.value.pageNo
      return arr
    case SEARCH_DATA:
      // 搜索 重置 分页
      arr.searchdata = action.value
      arr.pages.pageNo = 1
      return arr
    case CHANGE_PAGES:
      arr.pages = action.value
      return arr
    case SET_LOADING:
      arr.dataSource.loading = action.value
      return arr
    case CHANGE_DATA:
      arr = action.value
      return arr
    default:
      return state
  }
}

// 设置数据
const setdataAction = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}) => ({
  type: SET_DATA,
  value: param,
})
// 切换分页
const changepageAction = (param: { pageNo: number; pageSize?: number }) => ({
  type: CHANGE_PAGES,
  value: param,
})
// 搜索
const changesearchdataAction = (param: SearchItem) => ({
  type: SEARCH_DATA,
  value: param,
})
// loading
const changeloadingAction = (param: boolean) => ({
  type: SET_LOADING,
  value: param,
})

const useLaunchgoodsHook = () => {
  const state = useTypedSelector((state) => state.myReuestReducer)
  const dispatch = useDispatch()
  const { dataSource, pages } = state

  const supRoute = userRouter[1].url
  const query = useQuery()
  const status = query.get('status') || ''

  useEffect(() => {
    if (status === 'reject') {
      getdata({ ...state, ...{ searchdata: { checkState: '22' } } })
    } else {
      getdata(state)
    }

    // eslint-disable-next-line
  }, [status])

  // 获取列表数据
  const getdata = async (launchgoodsState: LaunchgoodsState) => {
    dispatch(changeloadingAction(true))
    // 在saga处理中 获取state
    const params = { ...launchgoodsState.pages, ...launchgoodsState.searchdata }
    const data = await GET_AUDITLIST({
      pageNo: params.pageNo, // 页码
      pageSize: params.pageSize, // 分页尺寸
      brand: params.brand,
      checkMan: params.checkMan,
      checkState: params.checkState,
      auditStartDate: params.auditStartDate,
      auditEndDate: params.auditEndDate,
      name: params.name,
      supplierId: getSupplierId(),
      schemeId: params.schemeId,
      tempCode: params.tempCode,
      model: params.model,
      unitCode: params.unitCode,
    })
    if (data.code === 0) {
      const resdata = data.data.content
      const count = data.data.totalCount
      const action = setdataAction({
        dataSource: { data: resdata, total: count, loading: false },
        pageNo: data.data.pageNo,
      })
      dispatch(action)
    } else {
      message.warning(data.msg)
      dispatch(changeloadingAction(false))
    }
  }

  // 搜索
  const onSearch = (params: any) => {
    // SearchItem
    const action = changesearchdataAction(params)
    dispatch(action)
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 分页
  const onChange = (pageNo: number, pageSize?: number) => {
    const action = changepageAction({
      pageNo: pageNo,
      pageSize: pageSize,
    })
    dispatch(action)
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    getdata(state)
  }

  // // 再次提交
  // const passSwitch = () => {
  //   const canReSubmit = checkData.every((item) => item.canReSubmit)
  //   if (checkData.length && canReSubmit) {
  //     const idArr = checkData.map((item) => item.id)
  //     CustomerConfirm({
  //       title: '提示',
  //       content: '确认再次提交？',
  //       onOk: () => {
  //         submitdata(String(idArr))
  //       },
  //     })
  //   } else if (!canReSubmit) {
  //     message.warn('含有不可通过项')
  //   } else {
  //     message.warn('请先勾选数据，再提交')
  //   }
  // }

  // // 批量 再次提交
  // const submitdata = async (assessId: string) => {
  //   message.loading('提交中', 0)
  //   const resData = await POST_RESUNBNIT_API({ assessIds: assessId })
  //   if (resData.code === 0) {
  //     message.success('已提交')
  //     getdata(state)
  //   }
  // }

  // 放弃
  const nopassSwitch = (id: string) => {
    const idArr = id
    CustomerConfirm({
      title: '提示',
      content: '确认放弃申请？',
      onOk: () => {
        givedata(String(idArr))
      },
    })
  }

  // 批量 放弃申请
  const givedata = async (assessId: string) => {
    message.loading('放弃中', 0)
    const resData = await POST_GIVEUP_API({ productIds: assessId })
    if (resData.code === 0) {
      message.success('已放弃')
      getdata(state)
    } else {
      message.destroy()
    }
  }

  // 撤回
  const onRecall = (info: any) => {
    CustomerConfirm({
      title: '提示',
      content: '确定撤回?',
      onOk() {
        recallApi(info)
      },
    })
  }

  // 撤回 recallApi
  const recallApi = async (assessId: string) => {
    message.loading('撤回中', 0)
    const resData = await POST_RECALL_API({ productId: assessId })
    if (resData.code === 0) {
      message.success('已撤回')
      getdata(state)
    }
  }

  // 物料编码跳转
  const onJump = (info: any) => {
    const assessState: myLaunchStateType = info.state
    const productMdmId = info.productMdmId
    // 审核来源：修改审核中→修改；其余（新增审核中/暂存/驳回/撤回）按新增兜底。
    // 实际资质场景以详情返参 auditType 为准（详情页 setDetailAuditType 推算）。
    let auditSource = 'SRM_SECOND_ADD'
    if (productStatusEnum.isLabelsMatchValue(['修改审核中'], assessState)) {
      auditSource = 'SRM_UPDATE'
    }
    if (
      productStatusEnum.isLabelsMatchValue(
        ['驳回', '撤回', '暂存'],
        assessState,
      )
    ) {
      // 编辑
      history.replace({
        pathname: `${supRoute}/launchgoodsInfo`,
        state: {
          productId: info.id,
          productMdmId: productMdmId,
          BtnState: [
            'Edit',
            productStatusEnum.isLabelsMatchValue(['驳回', '撤回'], assessState)
              ? 'AssessReject'
              : undefined,
          ],
          auditSource,
        },
      })
    } else {
      // 详情
      history.replace({
        pathname: `${supRoute}/goodsdetail`,
        state: {
          tempId: info.tempId,
          tempCode: info.tempCode,
          productId: info.id,
          BtnState: ['Detail'],
          auditSource,
        },
      })
    }
  }
  return {
    dataSource,
    pages,
    onSearch,
    onChange,
    onJump,
    onRecall,
    onRefresh,
    nopassSwitch,
    recallApi,
  }
}
export default useLaunchgoodsHook
